export default __webpack_public_path__ + "static/media/dude.b348eebe.jpg";